import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { Modal, ModalBody } from "react-bootstrap";
import VizParagraph from "../../VizParagraph/VizParagraph";
import VizButton from "../../VizButtons/VizButton";
import { updateGdriveAttrs, fetchDocumentsForGDRIVE } from "../../../API/api";
import { handleError } from "../../../utils";
import { toast } from "react-toastify";

export default function DeleteConfirmationModalGDrive() {
	const dispatch = useDispatch();
	const modalState = useSelector((state) => state.domain);
	const sharedFolderData = useSelector((state) => state.sharedFolderCMReducer)
	const { advanceFilterModalToggle, isLoadingSharedCMData, getgdriveDocumentsData } = bindActionCreators(Actions, dispatch);
	const [getFrequencyId, setFrequencyId] = useState(0);

	const onClickNoButton = () => {
		advanceFilterModalToggle({ bool: false, value: "" })
	}

	const submitSuccessToast = (message) => {
		return (
			<>
				<span style={{ fontSize: "12px" }}>
					{message}
				</span>
			</>
		);
	};



	const onClickYesButton = () => {
		let payload = {
			id: sharedFolderData.id,
			archive: true,
			folderName: sharedFolderData.folderName,
			frequency: getFrequencyId,
		}
		// {
		// 	"id": 32,
		// 	"archive": true,
		// 	"folderName": "gdriveFolderupdate1",
		// 	"frequency": 2
		// }
		updateGdriveAttrs(payload).then((res) => {
			if (res===undefined) return;
			if (res.data.success === true || res.data.data !== undefined) {
				advanceFilterModalToggle({ bool: false, value: "" })
				isLoadingSharedCMData(true);
				fetchDocumentsForGDRIVE().then((res) => {
					if (res===undefined) return;
					if (res.data.success === true || res.data.data !== undefined) {
						getgdriveDocumentsData(res.data.data);
						isLoadingSharedCMData(false);
						toast.success(submitSuccessToast(res.data.message), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}).then((err) => handleError(err))
			}
		}).catch((err) => handleError(err))
	}

	useEffect(() => {
		let newArr = sharedFolderData.frequency.filter((obj) => {
			if (obj.name === sharedFolderData.frequencyName) {
				return obj;
			}
		})
		setFrequencyId(newArr[0].id)
	}, [getFrequencyId])

	return (
		<Modal show={modalState.modalState}
			onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
			centered={true}
			size={"md"}
			backdrop="static"
			>
			<Modal.Header
				className="modalHeaderBackground"
				closeButton
				closeVariant="white"
			>
				<Modal.Title className="modalTitle">
					<i class="fa fa-files-o" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Delete Folder
				</Modal.Title>
			</Modal.Header>
			<ModalBody>
				<VizParagraph type={5} weight={1}>
					Are you sure, You want to delete this folder link?
				</VizParagraph>
				<div style={{ justifyContent: 'center', display: 'flex', flexWrap: 'wrap' }}>
					<div style={{ margin: '5px' }}>
						<VizButton type={'Primary'} size={3} onClick={onClickYesButton} >Yes</VizButton>
					</div>
					<div style={{ margin: '5px' }}>
						<VizButton type={'Tertiary'} size={3} onClick={onClickNoButton}>No</VizButton>
					</div>
				</div>
			</ModalBody>
		</Modal>
	)
}